module.exports = __webpack_public_path__ + "static/media/pigment-icon-dis.7bca2d39.svg";